import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { FaSun, FaMoon, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/images/svg/logo.svg";

function Navbar({ darkMode, setDarkMode }) {
  const { lang, setLang, t } = useLanguage();
  const [langOpen, setLangOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="portfolio-nav">
      <a href="#hero">
        <img src={logo} alt="Ahmada" className="nav-logo" />
      </a>

      <button
        className="nav-hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menu"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><a href="#about" onClick={() => setMenuOpen(false)}>{t("navAbout")}</a></li>
        <li><a href="#skills" onClick={() => setMenuOpen(false)}>{t("navSkills")}</a></li>
        <li><a href="#experience" onClick={() => setMenuOpen(false)}>{t("navExperience")}</a></li>
        <li><a href="#projects" onClick={() => setMenuOpen(false)}>{t("navProjects")}</a></li>
        <li><a href="#contact" onClick={() => setMenuOpen(false)}>{t("navContact")}</a></li>
      </ul>

      <div className="nav-controls">
        {/* Language Dropdown */}
        <div className="lang-dropdown">
          <button
            className="lang-btn"
            onClick={() => setLangOpen(!langOpen)}
          >
            {lang === "fr" ? "🇫🇷 FR" : "🇬🇧 EN"}
            <span style={{ fontSize: 8 }}>▼</span>
          </button>
          {langOpen && (
            <div className="lang-menu">
              <button
                className={`lang-option ${lang === "fr" ? "active" : ""}`}
                onClick={() => { setLang("fr"); setLangOpen(false); }}
              >
                🇫🇷 Français
              </button>
              <button
                className={`lang-option ${lang === "en" ? "active" : ""}`}
                onClick={() => { setLang("en"); setLangOpen(false); }}
              >
                🇬🇧 English
              </button>
            </div>
          )}
        </div>

        {/* Theme Toggle */}
        <button
          className="theme-btn"
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle theme"
        >
          {darkMode ? <FaSun /> : <FaMoon />}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
